export const SELECT_AD_TYPE_CY = {
  OPEN_MODAL_BTN: 'open-modal-btn',
  MODAL: 'select-ad-modal',
  OVERLAY: 'select-ad-overlay',
  CLOSE_BTN: 'ad-type-modal-close-btn',
  AD_TYPE: (key: string) => `select-ad-type-item-${key}`
};

export const PAYMENT_MODAL_CY = {
  MAIN_MODAL: 'payments-modal',
  OPEN_PROMOTE_BTN: 'open-promote-modal',
  CONFIRM_BTN: 'confirm-payment',
  SUCCESS_TOP_UP_MODAL: 'payment-top-up-success-modal',
  MODAL_OVERLAY: 'modal-overlay',
  PAYMENT_METHOD: (id: string | number) => `promote-ad-payment-method-${id}`,
  AMOUNT_CHIP: (id: string) => `amount-chip-${id}`,
  DEPOSIT_INPUT: 'deposit-input',
  TOP_UP_BTN: 'top-up-btn',
  ERROR_TOP_UP_MODAL: 'error-top-up-modal'
};

export const TAB_MENU_CY = {
  HOME: 'tab-menu-button-home',
  BOOKMARKS: 'tab-menu-button-bookmarks',
  ADD_AD: 'tab-menu-button-add-ad',
  PROFILE: 'tab-menu-button-profile',
  MORE_OPTIONS: 'tab-menu-button-more-options'
};

export const CREATE_AD_CY = {
  STEPPER_STEP: (index: number) => `stepper-step-${index}`,
  STEP_CONTINUE_BTN: 'step-continue-btn',
  STEP_BACK_BTN: 'step-back-btn',

  POSITION_NAME_INPUT: 'position-name-input',
  CATEGORY_TRIGGER: 'category-trigger',
  CATEGORY_MAIN_OPTION: (id: string | number) => `category-main-option-${id}`,
  CATEGORY_OPTION: (id: string | number) => `category-option-${id}`,
  SALARY_FROM_INPUT: 'salary-from-input',
  SALARY_TO_INPUT: 'salary-to-input',
  REGION_TRIGGER: 'region-trigger',
  REGION_OPTION: (id: string | number) => `region-option-${id}`,
  EDUCATION_OPTION: (id: string | number) => `education-option-${id}`,
  EXPERIENCE_OPTION: (id: string | number) => `experience-option-${id}`,
  AGE_FROM_INPUT: 'age-from-input',
  AGE_TO_INPUT: 'age-to-input'
};

export const RESUME_CY = {
  FIRSTNAME_INPUT: 'firstname-input',
  SURNAME_INPUT: 'surname-input',
  PATRONYMIC_INPUT: 'patronymic-input',

  DOB_DAY_INPUT: 'dob-day-input',
  DOB_MONTH_TRIGGER: 'dob-month-trigger',
  DOB_MONTH_OPTION: (id: string | number) => `dob-month-option-${id}`,
  DOB_YEAR_TRIGGER: 'dob-year-trigger',
  DOB_YEAR_OPTION: (id: string | number) => `dob-year-option-${id}`,

  GENDER: (value: string) => `gender-${value}`,

  DESCRIPTION_EDITOR: 'resume-description-editor',

  PHONE_INPUT: 'resume-phone-input',
  EMAIL_INPUT: 'resume-email-input'
};

export const VACANCY_CY = {
  AGE_FROM_INPUT: 'age-from-input',
  AGE_TO_INPUT: 'age-to-input',

  DESCRIPTION_EDITOR: 'vacancy-description-editor',

  CONTACT_NAME_INPUT: 'vacancy-contact-name-input',
  PHONE_INPUT: 'vacancy-phone-input',
  EMAIL_INPUT: 'vacancy-email-input',
  COMPANY_NAME_INPUT: 'vacancy-company-name-input'
};

export const AD_OTP_MODAL_CY = {
  MODAL: 'ad-otp-modal'
};

export const AD_CONTACTS_CY = {
  BUTTON: 'ad-contact-button',
  WARNING: 'ad-contact-warning'
};

export const TARIFF_CY = {
  CARD: (slug: string) => `tariff-card-${slug}`,
  FREE_CARD: 'tariff-free-card'
};
